import React from 'react';
import {
    Typography,
    Slider,
    Box,
    Stack,
    Paper,
    Popover,
    Rating,
    Button,
    ListItem,
    List,
    Divider,
    ListItemText, ButtonGroup
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Tooltip, {tooltipClasses} from "@mui/material/Tooltip";
import PropTypes from "prop-types";

import ScoreDots from "./ScoreDots";

const StrictlyCard = ({ 
    index, 
    places, 
    sliderValues, 
    radioValues, 
    onChangeBall,
    onChangeBallBonus,
    isReady,
    getColor 
}) => {
    return (
        <div style={{marginBottom: '10px'}}>
            <div style={{textAlign: "left"}}>№{places?.[index]?.number} {places?.[index]?.leader?.name} и {places?.[index]?.follower?.name}</div>
            <div style={{marginBottom: '5px'}}>
                <div style={{display: 'flex'}}>
                    <ScoreDots onSelect={onChangeBall(index, 'basic_leader')} max={5} name={"BL"}
                               disable={isReady} value={sliderValues[index]?.basic_leader}/>
                    {/*{Circle(sliderValues[index]?.basic_leader, 5)}*/}
                </div>
                <div style={{display: 'flex'}}>
                    <ScoreDots onSelect={onChangeBall(index, 'basic_follow')} max={5} name={"BF"}
                               disable={isReady} value={sliderValues[index]?.basic_follow}/>
                    {/*{Circle(sliderValues[index]?.basic_follow, 5)}*/}
                </div>
            </div>
            <div style={{marginBottom: '5px'}}>
                <div style={{display: 'flex'}}>
                    <ScoreDots onSelect={onChangeBall(index, 'lfbdh')} max={5} name={"LF"}
                               disable={isReady} value={sliderValues[index]?.lfbdh}/>
                    {/*{Circle(sliderValues[index]?.lfbdh, 5)}*/}
                </div>
                <div style={{display: 'flex'}}>
                    <ScoreDots onSelect={onChangeBall(index, 'dance_perf')} max={4} name={"DP"}
                               disable={isReady} value={sliderValues[index]?.dance_perf}/>
                    <ScoreDots onSelect={onChangeBallBonus(index, 'bonus1')} max={1} name={""} bonus
                               disable={isReady} value={radioValues[index]?.bonus1}/>
                    {/*{Circle(sliderValues[index]?.dance_perf, 4, radioValues[index]?.bonus1)}*/}
                </div>
            </div>
            <div style={{marginBottom: '5px'}}>
                <div style={{display: 'flex'}}>
                    <ScoreDots onSelect={onChangeBall(index, 'execution')} max={5} name={"EX"}
                               disable={isReady} value={sliderValues[index]?.execution}/>
                    {/*{Circle(sliderValues[index]?.execution, 5)}*/}
                </div>
                <div style={{display: 'flex'}}>
                    <ScoreDots onSelect={onChangeBall(index, 'diff_var')} max={4} name={"DV"}
                               disable={isReady} value={sliderValues[index]?.diff_var}/>
                    <ScoreDots onSelect={onChangeBallBonus(index, 'bonus2')} max={1} name={""} bonus
                               disable={isReady} value={radioValues[index]?.bonus2}/>
                    {/*{Circle(sliderValues[index]?.diff_var, 4, radioValues[index]?.bonus2)}*/}
                </div>
            </div>
            <div style={{display: 'flex'}}>
                <ScoreDots onSelect={onChangeBall(index, 'interpret')} max={5} name={"IN"}
                           disable={isReady} value={sliderValues[index]?.interpret}/>
                {/*{Circle(sliderValues[index]?.interpret, 5)}*/}
            </div>
            <div style={{display: 'flex'}}>
                <ScoreDots onSelect={onChangeBall(index, 'spontan')} max={4} name={"SP"}
                           disable={isReady} value={sliderValues[index]?.spontan}/>
                <ScoreDots onSelect={onChangeBallBonus(index, 'bonus3')} max={1} name={""} bonus
                           disable={isReady} value={radioValues[index]?.bonus3}/>
                {/*{Circle(sliderValues[index]?.spontan, 4, radioValues[index]?.bonus3)}*/}
            </div>
        </div>
    );
};

StrictlyCard.propTypes = {
    index: PropTypes.number.isRequired,
    places: PropTypes.array,
    sliderValues: PropTypes.array,
    radioValues: PropTypes.array,
    onChangeBall: PropTypes.func,
    onChangeBallBonus: PropTypes.func,
    isReady: PropTypes.bool,
    getColor: PropTypes.func
};

export default StrictlyCard;